import { GetterTree } from 'vuex';
import { RootState } from '@/store';

import { State } from './state';

export type Getters = {
  showModal(state: State): boolean | null;
  showModalFiltroEstudantes(state: State): boolean | null;
  showModalFiltroTurmas(state: State): boolean | null;
  showModalFiltroMultiTurmas(state: State): boolean | null;
  showModalAvisosNotificacoes(state: State): boolean | null;
  showModalLegado(state: State): boolean | null;
  getCodigoProfessorSelecionadoTelaFiltro(state: State, rootState: RootState): any | null;
  getNomeProfessorSelecionadoTelaFiltro(state: State, rootState: RootState): any | null;
  getTipoPesquisaFiltroFuncionarios(state: State, rootState: RootState): any | null;
  getRotaChamarFiltroFuncionarios(state: State, rootState: RootState): any | null;
  getCodigoEstudanteSelecionadoTelaFiltro(state: State, rootState: RootState): any | null;
  getCodigoTurmaSelecionadaTelaFiltro(state: State, rootState: RootState): any | null;
  getTipoPesquisaFiltroEstudantes(state: State, rootState: RootState): any | null;
  getRotaChamarFiltroEstudantes(state: State, rootState: RootState): any | null;
}

export const getters: GetterTree<State, RootState> & Getters = {
  showModal: (state) => state!.showModal,
  showModalFiltroEstudantes: (state) => state!.showModalFiltroEstudantes,
  showModalFiltroTurmas: (state) => state!.showModalFiltroTurmas,
  showModalFiltroMultiTurmas: (state) => state!.showModalFiltroMultiTurmas,
  showModalAvisosNotificacoes: (state) => state!.showModalAvisosNotificacoes,
  showModalLegado: (state) => state!.showModalLegado,
  getCodigoProfessorSelecionadoTelaFiltro: (state, rootState) => state.codigoProfessorSelectedTelaFiltro,
  getNomeProfessorSelecionadoTelaFiltro: (state, rootState) => state.nomeProfessorSelectedTelaFiltro,
  getTipoPesquisaFiltroFuncionarios: (state, rootState) => state.enumTipoPesquisaFiltroFuncionarios,
  getRotaChamarFiltroFuncionarios: (state, rootState) => state.routeAfterSelectFiltroFuncionarios,
  getCodigoEstudanteSelecionadoTelaFiltro: (state, rootState) => state.codigoEstudanteSelectedTelaFiltro,
  getCodigoTurmaSelecionadaTelaFiltro: (state, rootState) => state.codigoTurmaSelectedTelaFiltro,
  getTipoPesquisaFiltroEstudantes: (state, rootState) => state.enumTipoPesquisaFiltroEstudantes,
  getRotaChamarFiltroEstudantes: (state, rootState) => state.routeAfterSelectFiltroEstudantes,
};
